export { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, NAMESPACES } from './constants';
export type { SupportedLanguage } from './constants';
export { initI18n, i18nConfig } from './config';
